export default "__VITE_ASSET__9Fa41L6u__"